import { render } from 'preact';
import { ChatWidget, type WidgetConfig } from './ChatWidget';
import { resolveWidgetMarket } from './market';
import styles from './styles.css?inline';

function initialize(script: HTMLScriptElement) {
  if (script.dataset.blinkitChatMounted === 'true') return;
  script.dataset.blinkitChatMounted = 'true';

  const salonSlug = script.dataset.salonSlug;
  if (!salonSlug) {
    console.error('[Blinkit Chat] data-salon-slug is required.');
    return;
  }
  let market: string;
  try {
    market = resolveWidgetMarket(script.dataset.market);
  } catch {
    console.error('[Blinkit Chat] data-market is invalid.');
    return;
  }

  const config: WidgetConfig = {
    salonSlug,
    market,
    apiUrl: (script.dataset.apiUrl || 'http://127.0.0.1:8787').replace(/\/$/, ''),
    locale: script.dataset.locale || 'en',
    initiallyOpen: script.dataset.open === 'true',
    placement: script.dataset.placement === 'left' ? 'left' : 'right',
    presentation: script.dataset.mode === 'page' ? 'page' : 'widget',
  };

  const host = document.createElement('div');
  host.setAttribute('data-blinkit-chat-host', salonSlug);
  script.parentNode?.insertBefore(host, script.nextSibling);

  const shadow = host.attachShadow({ mode: 'open' });
  const style = document.createElement('style');
  style.textContent = styles;
  shadow.appendChild(style);
  const root = document.createElement('div');
  shadow.appendChild(root);
  render(<ChatWidget config={config} />, root);
}

function initializeAll() {
  document
    .querySelectorAll<HTMLScriptElement>('script[data-blinkit-chat]')
    .forEach(initialize);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
} else {
  initializeAll();
}
